// Shared Supabase client — import this everywhere instead of
// calling createClient() in each component. Eliminates the
// "Multiple GoTrueClient instances detected" warning that fires
// when multiple modules each instantiate their own client.
import { createClient } from '@supabase/supabase-js';

const supabase = createClient(
  process.env.REACT_APP_SUPABASE_URL,
  process.env.REACT_APP_SUPABASE_ANON_KEY
);

export default supabase;
